import styled from 'styled-components';

export const StyledSideBarComp = styled.div`
  width: 80px;
  height: 80px;
  margin-top: 20px;
  margin-bottom: 20px;
  border-radius: 50%;
  background-color: tomato;
  text-align: center;
  line-height: 80px;
  font-size: 13px;
  font-family: 'NexonBo';
`;

export const StyledSideBar = styled.div`
  width: 100px;
  margin-left: 40px;
  margin-top: 20px;
  float: left;
  cursor: pointer;
`;
